import moment from "moment";
import ActionButtonDokumenti from "./ActionButtonDokumenti";

const DokumentaCNRList = (props: any) => {
  return (
    <>
      {props.listaDCNR.map((lista: any) => (
        <tr key={lista.id}>
          <td>{lista.decision_number}</td>
          <td className="list-center w-100">{lista.content.cg && lista.content.cg.length > 150 ? lista.content.cg.slice(0,150) + '...' : lista.content.cg}</td>
          <td>{moment(lista.date_of_decision).format('DD-MM-YYYY')}</td>

          <td>
            <ActionButtonDokumenti id={lista.id} />
          </td>
        </tr>
      ))}
    </>
  );
};

export default DokumentaCNRList;
